module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/siena.61b8778fcf4c916888c9813227eb0d8f.jpg";